import * as React from 'react';

export default class SubItems extends React.Component {
  render() {
    return (
        <ul>
            {this.props.children}
        </ul>
    );
  }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-react-wrapper/src/panelbar/subitems.tsx